<template>
  <div id="CHMAS">儿童健康管理页，正在开发中~</div>
</template>
<script>
export default {

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/Solution/CHMAS.vue